// import decode from "jwt-decode";
import {
	AUTH_ERROR,
	LOGIN_FAIL,
	LOGIN_SUCCESS,
	LOGOUT,
	USER_LOADED,
	CLEAR_ERROR,
} from "../types";
// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
	switch (action.type) {
		case USER_LOADED:
			return {
				...state,
				user: action.payload.user,
			};

		case LOGIN_SUCCESS:
			localStorage.setItem("token", action.payload.user);
			// const decoded = decode(action.payload.user.data.token);
			return {
				...state,
				token: action.payload.user,
				error: null,
			};
		case CLEAR_ERROR:
			return {
				...state,
				error: null,
			};
		case LOGIN_FAIL:
		case AUTH_ERROR:
		case LOGOUT:
			localStorage.removeItem("token");
			return {
				...state,
				token: null,
				user: null,
				error: action.payload,
			};

		default:
			return state;
	}
};
